import React from 'react';
import {AsyncComponent} from "../../../core/components/router/async-component";
import {GamesPredictionsWidgetPlaceholder} from "./placeholder/games-predictions-widget.placeholder";
import {ErrorBoundaryWrapper} from "../../../core/components/error-boundary/error-boundary-wrapper";

const GamesPredictionsWidgetAsyncComponent = AsyncComponent(async () => import('./games-predictions-widget' /* webpackChunkName: "games-predictions-widget" */ ));

export const GamesPredictionsWidgetAsync = (props) => {
  return <ErrorBoundaryWrapper>
    <React.Suspense fallback={<GamesPredictionsWidgetPlaceholder {...props}/>}>
      <GamesPredictionsWidgetAsyncComponent {...props}/>
    </React.Suspense>
  </ErrorBoundaryWrapper>
}
